// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".details{width:33.5rem;text-align:center;color:#666;font-size:1rem;line-height:1.5rem}.logout{color:#48bfe3;cursor:pointer}.details_container{margin-top:10rem}@media (max-width:991.98px){.details{width:auto}.details_container{padding:0 .2rem;margin-top:0}.details_container h2{font-size:1.625rem}.details_container p{font-size:.875rem}}", ""]);
// Exports
module.exports = exports;
